import { render } from "./dlt-2.vue?vue&type=template&id=3d62c7cd&scoped=true"
import script from "./dlt-2.vue?vue&type=script&lang=js"
export * from "./dlt-2.vue?vue&type=script&lang=js"

import "./dlt-2.vue?vue&type=style&index=0&id=3d62c7cd&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d62c7cd"]])

export default __exports__